import baseAuthAdminQuery from './baseAuthAdminQuery';

export async function getSurvey({ id, employeeToken }) {
  if (!id) return;

  let path = `surveys/${id}`;
  if (employeeToken) {
    path = `${path}?employee_token=${encodeURIComponent(employeeToken)}`;
  }

  const response = await baseAuthAdminQuery({
    path,
    method: 'get',
  });

  return response?.data;
}

export async function getSurveyUser(args = {}) {
  const { employeeToken } = args;

  let path = 'survey_user';
  if (employeeToken) {
    path = `${path}?employee_token=${encodeURIComponent(employeeToken)}`;
  }

  const response = await baseAuthAdminQuery({
    path,
    method: 'get',
  });

  return response?.data;
}

export async function saveAnswer(props) {
  const { surveyId, surveyQuestionId, answer, otherText, employeeToken, utmTags = {}, locale } = props;

  const path = `surveys/${surveyId}/survey_questions/${surveyQuestionId}`;

  const response = await baseAuthAdminQuery({
    path,
    method: 'put',
    data: {
      result: answer,
      other_text: otherText,
      employee_token: employeeToken,
      ...utmTags,
    },
    locale,
  });

  return response?.data;
}

export async function getSurveyList() {
  const response = await baseAuthAdminQuery({
    path: 'survey_center',
    method: 'get',
  });

  return response?.data;
}

export async function getSurveyType({ id, employeeToken }) {
  if (!id) return;

  let path = `surveys/${id}/type`;
  if (employeeToken) {
    path = `${path}?employee_token=${encodeURIComponent(employeeToken)}`;
  }

  const response = await baseAuthAdminQuery({
    path,
    method: 'get',
  });

  return response?.data;
}
